import { useQueryClient } from '@tanstack/react-query';
import { uniqBy } from 'lodash-es';
import { CurrentUserQueryKeys, type FetchCurrentUserErpCustomersResponseData } from './current-user-api';

export const useGetCurrentUserErpCustomersSelector = () => {
  const queryClient = useQueryClient();

  const queries = queryClient.getQueriesData({
    queryKey: [CurrentUserQueryKeys.GET_CURRENT_USER_ERP_CUSTOMERS],
  });

  const customersFromQueries = queries.flatMap((query) => {
    const queryData = query[1] as FetchCurrentUserErpCustomersResponseData;
    const customers = queryData ? queryData.data : ([] as FetchCurrentUserErpCustomersResponseData['data']);
    return customers;
  });
  const uniqueCustomers = uniqBy(customersFromQueries, 'id');

  return uniqueCustomers;
};
